<div *ngIf="adBlockDetected" class="adblock-overlay">
  <div class="adblock-icon">
    <i class="fa fa-ban"></i>
  </div>

  <div class="adblock-message">
    <p>
      Por favor, desative o bloqueador de anúncios para continuar navegando.
    </p>
  </div>

  <button class="adblock-button" (click)="dismissOverlay()">
    Eu desativei o bloqueador
  </button>
</div>
